import type { userApiSpec } from "@wingspanhq/wingspan-api-types";
import { INewUser } from "@wingspanhq/users";
import { isSameDateSafe } from "../../../../utils/dates";
import { FormPartialDataUsPersonInfo } from "../FormPartialUsPersonInfo";

export const getUsPersonData = (
  userProfile: userApiSpec.UserProfileResponse | undefined,
  user: INewUser | undefined
): Partial<FormPartialDataUsPersonInfo> => {
  return {
    firstName: userProfile?.taxProfiles?.["US"]?.firstName,
    lastName: userProfile?.taxProfiles?.["US"]?.lastName,
    usPersonDate: userProfile?.taxProfiles?.["US"]?.startDate,
    usPersonSince: isSameDateSafe(
      user?.profile.dob,
      userProfile?.taxProfiles?.["US"]?.startDate
    )
      ? "always"
      : "date"
  };
};
